type TeqplayLogoProps = React.SVGProps<SVGSVGElement>

/**
 * @todo - PFL-99: Move to @teqplay/ui
 */
const TeqplayLogo: React.FC<TeqplayLogoProps> = ({ ...props }) => {
  return (
    <svg viewBox="0 0 156 156" fill="none" {...props}>
      <path
        d="M0 78C0 34.9218 34.9218 0 78 0C121.078 0 156 34.9218 156 78C156 121.078 121.078 156 78 156C34.9218 156 0 121.078 0 78Z"
        fill="#21A2DC"
      />
      <path
        d="M100.111 63.3233C86.5389 48.3974 69.9411 47.8026 56.4782 63.3233L48.0377 54.7782C62.5819 34.4094 93.135 34.1305 108.516 54.6387L100.111 63.3233Z"
        fill="white"
      />
      <path
        d="M42.1684 48.7566C60.7101 25.5709 94.6013 25.3558 114.623 48.7566L123.006 40.4975C99.4817 12.4665 57.6855 11.5906 33.4089 40.4975L42.1684 48.7566Z"
        fill="white"
      />
      <path
        d="M47.9077 110.84L77.4296 81.0783L108.751 74.1179L101.791 105.2L71.9091 135.081L68.0689 115.16L47.9077 110.84Z"
        fill="white"
      />
    </svg>
  )
}

export default TeqplayLogo
